import { FC, useEffect } from 'react';
import { useFlashTransition } from '__hooks/useFlashState';
import TextInput from '__components/Inputs/TextInput';
import { useTranslation } from 'react-i18next';

export const EmailInput: FC<{
  value?: string | null;
  error?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  disabled: boolean;
  label: string;
  labelInfo?: string;
  required?: boolean;
  margin?: boolean;
}> = ({ value, error, onChange, onBlur, disabled, ...rest }) => {
  const { t } = useTranslation();
  const [, showErrorMessage, flashError, cancelFlash] = useFlashTransition();

  useEffect(() => {
    if (error) {
      flashError(error);
    }
  }, [error, flashError]);

  const handleChange = (v: string) => {
    onChange(v);
    cancelFlash();
  };

  return (
    <TextInput
      value={value}
      error={error}
      validate={{
        message: error,
        showMessage: showErrorMessage,
      }}
      onChange={handleChange}
      onBlur={onBlur}
      disabled={disabled}
      labelInfoPlacement="top"
      placeholder={t('Email')}
      {...rest}
    />
  );
};
